export default from './OptionalInfoForm';



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/components/OptionalInfoForm/index.js